import React from "react";

function Visahelp({ data, heading, img }) {
  return (
    <section className="layout-section pt-8">
      <div className="layout-container">
        <h1 id="heading-large" className="text-center mb-6">
          {heading}
        </h1>
        <div className="flex flex-col lg:flex-row items-center gap-8">
          <div className="w-full lg:w-1/2 space-y-4">
            {data.map((visa, index) => (
              <div key={index} className="border rounded-md p-4 bg-white shadow-sm">
                <h2 id="heading-md">{visa.heading}</h2>
                <p id="dark" className="mt-2 text-gray-600">{visa.description}</p>
              </div>
            ))}
          </div>
          <div className="w-full lg:w-1/2 flex justify-center">
            <img src={img} alt={heading} className="w-full max-w-md rounded-lg object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Visahelp;
